import { useState } from "react";

const LAYERS = {
  ai: { title: "AI Models", text: "Industry-specific AI models and intelligence." },
  data: { title: "Data Layer", text: "A unified, connected enterprise data foundation." },
  workflow: { title: "Workflow Engine", text: "Intelligent automation across business workflows." },
  integration: { title: "Integration Layer", text: "Connects to systems, people and external platforms." },
};

// Interactive ORAYA Intelligence Core diagram.
export function ArchitectureDiagram() {
  const [hover, setHover] = useState(null);
  const node = (key, pos) => (
    <button
      key={key}
      onMouseEnter={() => setHover(key)}
      onMouseLeave={() => setHover(null)}
      onFocus={() => setHover(key)}
      onBlur={() => setHover(null)}
      onClick={() => setHover(key)}
      data-testid={`arch-node-${key}`}
      className={`absolute ${pos} -translate-x-1/2 -translate-y-1/2 rounded-2xl px-5 py-4 min-w-[150px] transition-all duration-400 ${hover === key ? "glass-heavy border-hairline/25 scale-[1.03]" : "glass-medium hover:border-hairline/15"}`}
    >
      <span className="block text-sm font-medium text-ink">{LAYERS[key].title}</span>
    </button>
  );

  return (
    <div data-testid="architecture-diagram">
      <div className="relative w-full h-[440px] hidden md:block">
        <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 800 440" preserveAspectRatio="none">
          <g stroke="rgba(255,255,255,0.14)" strokeWidth="1" fill="none">
            <line x1="400" y1="220" x2="180" y2="90" />
            <line x1="400" y1="220" x2="620" y2="90" />
            <line x1="400" y1="220" x2="180" y2="350" />
            <line x1="400" y1="220" x2="620" y2="350" />
          </g>
          <g stroke="#4F6BFF" strokeWidth="1.4" fill="none" strokeDasharray="4 10" className="animate-dash" opacity="0.5">
            <line x1="400" y1="220" x2="180" y2="90" />
            <line x1="400" y1="220" x2="620" y2="90" />
            <line x1="400" y1="220" x2="180" y2="350" />
            <line x1="400" y1="220" x2="620" y2="350" />
          </g>
        </svg>

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full w-52 h-52 glass-heavy border-hairline/20 flex flex-col items-center justify-center text-center">
          <span className="display text-2xl font-medium tracking-[0.2em] text-ink">ORAYA</span>
          <span className="text-xs uppercase tracking-[0.2em] text-subtle mt-1">Intelligence Core</span>
        </div>

        {node("ai", "top-[90px] left-[180px]")}
        {node("data", "top-[90px] left-[620px]")}
        {node("workflow", "top-[350px] left-[180px]")}
        {node("integration", "top-[350px] left-[620px]")}

        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-center max-w-md">
          <p className="text-sm text-subtle min-h-[40px]">
            {hover ? LAYERS[hover].text : "Data → Intelligence → Decision → Action → Learning"}
          </p>
        </div>
      </div>

      {/* Mobile vertical */}
      <div className="md:hidden flex flex-col gap-3">
        <div className="rounded-2xl p-6 glass-heavy border-hairline/20 text-center">
          <span className="display text-xl font-medium tracking-[0.2em] text-ink">ORAYA</span>
          <span className="block text-xs uppercase tracking-[0.2em] text-subtle mt-1">Intelligence Core</span>
        </div>
        {Object.keys(LAYERS).map((k) => (
          <div key={k} className="rounded-2xl p-5 glass-medium" data-testid={`arch-node-mobile-${k}`}>
            <span className="block text-sm font-medium text-ink">{LAYERS[k].title}</span>
            <span className="block text-sm text-subtle mt-1">{LAYERS[k].text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
